import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { SearchFilter } from "domains/search/components/SearchFilter/SearchFilter";

export const SearchFilterModal = () => {
  const translate = useTranslate();
  return (
    <>
      <ModalHeader title={translate("app.filter.title")} />
      <SearchFilter />
    </>
  );
};
